 import Vue from 'vue'
import VueCookies from 'vue-cookies'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import store from './store'
import echarts from 'echarts'
import axios from '@/api/index.js'
import echartsWordcloud from 'echarts-wordcloud'
import LightTimeline from 'vue-light-timeline'
import VueClipboard from 'vue-clipboard2'
import promptbox from '@/components/js/promptbox.js' //引用全局组件
import moment from 'moment'
// import HappyScroll from 'vue-happy-scroll'
//  //引入css
// import 'vue-happy-scroll/docs/happy-scroll.css'
//  Vue.use(HappyScroll)

import utils from '@/util/utils.js'

import Confirm from '@/components/js/myConfirm.js'
import {encrypt,decrypt} from  '@/util/jsencrypt.js'

Vue.prototype.$my_confirm = Confirm.install;


//全局样式
import '@/assets/iconfont/iconfont.css'
import "@/assets/css/common.less"
import "@/assets/css/color.less"

import domtoimage from 'dom-to-image'
import fileSaver from 'file-saver'

import html2canvas from "html2canvas"

Vue.prototype.$html2canvas = html2canvas;
Vue.prototype.$encrypt = encrypt
Vue.prototype.$decrypt = decrypt


Vue.use(VueCookies)
Vue.use(ElementUI)


Vue.use(LightTimeline)
Vue.use(VueClipboard)
Vue.use(promptbox)
Vue.use(utils)
Vue.prototype.$utils = utils
Vue.prototype.$promptbox = promptbox
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts

Vue.prototype.$axios = axios
Vue.prototype.$moment = moment
Vue.prototype.domtoimage = domtoimage
Vue.prototype.fileSaver = fileSaver

//重置表单，formRef为表单的ref值数组，excludeFields为要排除重新初始化值得属性
Vue.prototype.$reset = function(formRefs, excludeFields) {
	// if (formRefs.length > 0) {
	// 	formRefs.forEach((item) => {
	// 		this.$refs[item].resetFields();
	// 	})
	// }

	if (formRefs) {
		this.$refs[formRefs].resetFields();
	}
	let obj1 = this.$data;
	let obj2 = this.$options.data.call(this);
	if (!excludeFields || excludeFields.length === 0) {
		excludeFields = ["ruleValidate"];
	}
	for (let attrName in obj1) {
		if (excludeFields && excludeFields.includes(attrName)) {
			continue;
		}
		obj1[attrName] = obj2[attrName];
	}
};

// let userInfo = $cookies.get("userInfo")

// Vue.prototype.$showBlock = true
// if (!userInfo) {
// 	userInfo = $cookies.get("userInfo")
// }
// if (userInfo && userInfo.readOnly == 1) {
// 	Vue.prototype.$showBlock = false
// }
// const readonly = Vue.directive('readonly', {
// 	inserted: function(el) {
// 		if (!userInfo) {
// 			userInfo = $cookies.get("userInfo")
// 		}
// 		if (userInfo.readOnly == 1) {
// 			el.setAttribute("style", 'display:none')
// 		}
// 	}
// })
// Vue.prototype.$showBlock=function () {
// 	userInfo = $cookies.get("userInfo")
// 	if (userInfo.readOnly == 1) {
// 		return true
// 	}
// 	return false
// }
// Vue.prototype.$isReadonly = function () {
// 	userInfo = $cookies.get("userInfo")
// 	if (userInfo.readOnly == 1) {
// 		return true
// 	}
// 	return false
// }


new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
